import _ from 'underscore';

export const formatGTMContainers = ({ GTMContainers = [], InstalledGTMContainers = [] } = {}) => {
  const others = _.filter(GTMContainers, container => _.every(InstalledGTMContainers, installedContainer => installedContainer.ContainerId !== container.ContainerId));
  return {
    allContainers: GTMContainers,
    installedContainers: InstalledGTMContainers,
    others,
  };
};
